import { Option, none } from '@sapphire/result';
import {
  SurveyQualification,
  SurveyQualificationCondition,
  SurveySelectableQualification,
} from '../models/survey-qualification.model';
import { isAdvancedTargetingQualification } from '../qualifications/qualification-info';

function isSelectableQualification(
  surveyQualification: SurveyQualification,
): surveyQualification is SurveySelectableQualification {
  return !surveyQualification.isRangeType;
}

function isRangeQualification(
  surveyQualification: SurveyQualification,
): boolean {
  return surveyQualification.isRangeType;
}

export class SurveyQualificationInfo {
  constructor(private readonly _surveyQualification: SurveyQualification) {}

  public isSelectable(): boolean {
    return isSelectableQualification(this._surveyQualification);
  }

  public isRange(): boolean {
    return isRangeQualification(this._surveyQualification);
  }

  public conditionCodes(): string[] {
    return isSelectableQualification(this._surveyQualification)
      ? this._surveyQualification.conditionCodes
      : [];
  }

  public selectedOptionsData(): SurveyQualificationCondition[] {
    return isSelectableQualification(this._surveyQualification)
      ? this._surveyQualification.data
      : [];
  }

  public rangeValue(): Option<{ min: number; max: number }> {
    if (isSelectableQualification(this._surveyQualification)) {
      return none;
    }

    const [rangeDatum] = this._surveyQualification.data;
    return Option.from(
      rangeDatum ? { min: rangeDatum.min, max: rangeDatum.max } : null,
    );
  }

  public hasQuotas(): boolean {
    return this._surveyQualification.isQuotaSet;
  }

  public hasSelectedOptions(): boolean {
    return this.isRange()
      ? this.rangeValue().isSome()
      : this.conditionCodes().length > 0;
  }

  public isDefault(): boolean {
    return this._surveyQualification.isDefault;
  }

  public isAdvanced(): boolean {
    return isAdvancedTargetingQualification(this._surveyQualification);
  }
}
